import { Directive } from '@angular/core';

@Directive({
	selector: 'ngx-dropzone-label'
})
export class NgxDropzoneLabelDirective { }
